// extracted by mini-css-extract-plugin
export var closeButton = "_io-2";
export var closeButtonIcon = "_io-3";
export var lightboxContent = "_io-1";
export var lightboxOverlay = "_io-0";